import React, { useEffect, useState } from 'react';
import {
    AudioOutlined,
    CameraOutlined,
    SettingOutlined,
    ShareAltOutlined
} from "@ant-design/icons";
import VoxeetSDK from "@voxeet/voxeet-web-sdk";

import { useRoomStore } from '../../../stores/room';
import { useUserStore } from '../../../stores/user';
import { UserStream } from '../../../widgets/user';

import { ReactComponent as SettingsIcon } from '../icons/settings.svg';
import { ReactComponent as ArrowIcon } from '../icons/arrow-left.svg';

import styles from './direct.module.css';
import { useNavigate } from 'react-router';

export function DirectRoom({
    onReady,
    onOpenSettings,
    onOpenShare
}){
    const navigate = useNavigate();
    const { id, participants, update, locked, name, spaceId, created } = useRoomStore();
    const { id: userId } = useUserStore();
    const [loading, setLoading] = useState(true);
    const currentParticipant = participants.find(participant => participant.pesuId === userId);
    const otherParticipants = participants.filter(participant => participant.pesuId !== userId && (participant.status === 'Connected' || participant.status === 'Connecting' || participant.status === 'Inactive'));
    const activeParticipants = [currentParticipant, ...otherParticipants];
    const me = participants.find((p) => p.pesuId === userId);
    useEffect(() => {
        onReady({
            scale: 0
        }).then(() => {
            setLoading(false);
        })
    },[])
    return !loading ? <div className={styles.direct}>
        <div className={'toolbar'}>
            <button onClick={() => {
                navigate(`/spaces/${spaceId}`);
            }} className={'back'}>
                <ArrowIcon />
            </button>
            <h1>{name}</h1>
            <span style={{flex: "1 1 100%"}} />
            {created?.by === userId && <button className={'warning'} onClick={() => {
                update(id, { locked: !locked });
            }}>{locked ? 'Unlock' : 'Lock'} Room</button>}
            <button className={me?.audioTransmitting ? '' : 'crossed'} onClick={() => {
                if(me?.audioTransmitting){
                    VoxeetSDK.conference.stopAudio(VoxeetSDK.session.participant);
                }
                else{
                    VoxeetSDK.conference.playBlockedAudio();
                    VoxeetSDK.conference.startAudio(VoxeetSDK.session.participant);
                }
            }} ><AudioOutlined /></button>
            <button className={me?.stream ? '' : 'crossed'} onClick={() => {
                if(me.stream && me.stream.getVideoTracks().length > 0){
                    VoxeetSDK.conference.stopVideo(VoxeetSDK.session.participant);
                  }
                  else{
                    VoxeetSDK.conference.startVideo(VoxeetSDK.session.participant);
                  }
            }} ><CameraOutlined /></button>
            <button onClick={onOpenShare}><ShareAltOutlined /></button>
            <button onClick={onOpenSettings}><SettingsIcon /></button>
        </div>
        <div className={`${styles.room} ${styles[`count${activeParticipants.length}`]}`} data-count={activeParticipants.length}>
            {activeParticipants.filter(p => !!p).map(p => <UserStream name={p.name} participant={p} showName={p.pesuId !== userId} className={styles.stream} />)}
        </div>
    </div> : ""
}